import React from 'react';
import { TFunction } from 'i18next';
import {
  FolderIcon,
  MyAdsIcon,
  Profile2Icon,
  TransactionsIcon,
  WalletIcon,
} from '@/components/UI/Icons/Icons';
import { ROUTES } from '@/constants/routes';
import { AdStatus } from '@/types';

export const MY_ADS_PATHS = [
  ROUTES.profileAds(AdStatus.Published),
  ROUTES.profileAds(AdStatus.Pending),
  ROUTES.profileAds(AdStatus.AwaitingPayment),
  ROUTES.profileAds(AdStatus.Expired),
  ROUTES.profileAds(AdStatus.Rejected),
  ROUTES.profileAds(AdStatus.Archived),
];

export const getProfileNavItems = (t: TFunction) => [
  {
    title: t('pages.cabinet.my_ads'),
    href: ROUTES.profileAds(AdStatus.Published),
    icon: <MyAdsIcon />,
  },
  {
    title: t('pages.cabinet.operations_history'),
    href: ROUTES.accountTxs,
    icon: <TransactionsIcon />,
  },
  {
    title: t('pages.cabinet.my_cards'),
    href: ROUTES.cards,
    icon: <WalletIcon />,
  },
  {
    title: t('pages.cabinet.limits'),
    href: ROUTES.limits,
    icon: <FolderIcon />,
  },
  {
    title: t('pages.cabinet.profile'),
    href: ROUTES.editProfile,
    icon: <Profile2Icon />,
  },
];

export const getMobileProfileMenuItems = (t: TFunction) => [
  {
    title: t('pages.cabinet.my_ads'),
    href: ROUTES.profileAds(AdStatus.Published),
    icon: <MyAdsIcon />,
  },
  {
    title: t('pages.cabinet.operations_history'),
    href: ROUTES.accountTxs,
    icon: <TransactionsIcon />,
  },
  {
    title: t('pages.cabinet.my_cards'),
    href: ROUTES.cards,
    icon: <WalletIcon />,
  },
  {
    title: t('pages.cabinet.limits'),
    href: ROUTES.limits,
    icon: <FolderIcon />,
  },
  {
    title: t('pages.cabinet.profile'),
    href: ROUTES.editProfile,
    icon: <Profile2Icon />,
  },
];

export const getMobileProfileQuickNavItems = (t: TFunction) => [
  {
    title: t('pages.cabinet.operations_history'),
    href: ROUTES.accountTxs,
    icon: <TransactionsIcon />,
  },
  {
    title: t('pages.cabinet.my_cards'),
    href: ROUTES.cards,
    icon: <WalletIcon />,
  },
  {
    title: t('pages.cabinet.limits'),
    href: ROUTES.limits,
    icon: <FolderIcon />,
  },
];
